define((require) => {
    "use strict";

    const ImprovedView              = require("editor/zbone/ImprovedView");
    const DropAreaHotspot           = require("ui/behaviors/DropAreaHotspot");
    const CustomFontCollectionView  = require("editor/ui/settings/fonts/CustomFontCollectionView");
    const CustomFontCollection      = require("editor/services/fonts/customFonts/CustomFontCollection");
    const CustomFontDropManager     = require("services/CustomFontDropManager");
    const FontProvider              = require("shared/data/fonts/FontProvider");
    const EditorWebFontController   = require("editor/ui/experience/editor/EditorWebFontController");
    const template                  = require("editor/ui/settings/fonts/ManageCustomFontsIntegrationView.tpl");

    return ImprovedView.extend("ManageCustomFontsIntegrationView", {

        className: "tab-pane",

        template,

        regions: {
            "fontCollectionRegion": ".font-collection-region"
        },

        behaviors: {
            dropAreaHotspot: {
                behaviorClass: DropAreaHotspot,
                dropManager: CustomFontDropManager,
                message: "<h4>Add <br/>Custom Fonts</h4><p>Drag from desktop or click to upload</p>",
                dropAreaSelector: ".font-drop-area",
                iconSize: "small"
            }
        },

        initialize() {
            this._collection = new CustomFontCollection();
            this._collection.fetch();
        },

        /**
         * Invoked when uploading (triggered by the `DropAreaHotspot`).
         *
         * @param {Promise} options.promise Fulfilled when upload completes.
         * @param {CustomFontModel[]} options.models The font models.
         *
         * @see CustomFontDropManager
         */
        onUpload({promise, descriptors, models}) {
            this._collection.add(models);

            promise.then(() => {
                EditorWebFontController.register(models, FontProvider.CUSTOM);
            });

            // Handle failed uploads...
            descriptors.forEach((uploadDescriptor) => {
                uploadDescriptor.promise.fail(() => {
                    this._collection.remove(uploadDescriptor.model);
                });
            });
        },

        onShow() {
            const collectionView = new CustomFontCollectionView({collection: this._collection});
            this.fontCollectionRegion.show(collectionView);
        },

        active(state) {
            this.$el.toggleClass("active", state);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/fonts/ManageCustomFontsIntegrationView.js